import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import Landing from '@/pages/Landing';
import SearchPage from '@/pages/SearchPage';
import TradieProfilePage from '@/pages/TradieProfilePage';
import TradieDashboard from '@/pages/TradieDashboard';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import AdminPanel from '@/pages/AdminPanel';
import SavedTrades from '@/pages/SavedTrades';
import ForTradies from '@/pages/ForTradies';
import Compliance from '@/pages/Compliance';
import AgencyPortal from '@/pages/AgencyPortal';
import TradeDeals from '@/pages/TradeDeals';
import SuburbLanding from '@/pages/SuburbLanding';
import PerthTradesIndex from '@/pages/PerthTradesIndex';
import AgencyPricing from '@/pages/AgencyPricing';
import RemovalRequest from '@/pages/RemovalRequest';
import PassportMarketing from '@/pages/PassportMarketing';
import PortfolioDashboard from '@/pages/PortfolioDashboard';
import RiskTrustModule from '@/pages/RiskTrustModule';
import MyProperty from '@/pages/MyProperty';
import ContractorPanel from '@/pages/ContractorPanel';
import JobDetail from '@/pages/JobDetail';
import PublicPassportShare from '@/pages/PublicPassportShare';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';
import ChatWidget from '@/components/ChatWidget';
import CallFeedbackPrompt from '@/components/CallFeedbackPrompt';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/tradie/:id" element={<TradieProfilePage />} />
          <Route path="/tradie" element={<TradieDashboard />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/passport" element={<PassportMarketing />} />
          <Route path="/portfolio" element={<PortfolioDashboard />} />
          <Route path="/portfolio/panel" element={<ContractorPanel />} />
          <Route path="/my-property" element={<MyProperty />} />
          <Route path="/pn/jobs/:id" element={<JobDetail />} />
          <Route path="/passport-share/:token" element={<PublicPassportShare />} />
          <Route path="/risk-trust" element={<RiskTrustModule />} />
          <Route path="/agency" element={<AgencyPortal />} />
          <Route path="/agency/pricing" element={<AgencyPricing />} />
          <Route path="/deals" element={<TradeDeals />} />
          <Route path="/perth-trades" element={<PerthTradesIndex />} />
          <Route path="/l/:category/:suburb" element={<SuburbLanding />} />
          <Route path="/removal-request" element={<RemovalRequest />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/saved" element={<SavedTrades />} />
          <Route path="/for-tradies" element={<ForTradies />} />
        </Routes>
        <CallFeedbackPrompt />
        <ChatWidget />
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 500,
            border: '1px solid #1C1B1A',
            borderRadius: 0,
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
